export enum SettingsCourseDetailsScreenOptions {
  DISABLED = 'disabled',
  ENABLED_FOR_LOGGED_IN_USERS = 'enabled_for_logged_users',
  ENABLED_FOR_ALL_USERS = 'enabled_for_all_users'
}
